import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=6a664412&"
import script from "./FormStep.vue?vue&type=script&lang=js&"
export * from "./FormStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports